import {
  Form,
  SubmitFormButton,
  TextField
} from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { GridItem } from '@calendly/ui/components/grid'
import { last } from 'lodash-es'
import { useEffect, useMemo, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'


import { StepControls } from 'features/organization_settings/shared/step'
import { orgSessionSettingsSelector } from 'selectors/current_organization'

import { CertificateFileInput } from './certificate_file_input'
import { errorsSelector, samlSettingsSelector } from './selectors'
import { durations, SessionDurationSelectField } from './session_duration_select_field'
import { saveSamlSsoSettings } from './thunks'
import { buildValidationSchema } from './validation_schema'
import { Row, Hint, CertificateLabel, JustifiedGrid } from '../shared/styles'


const defaultDurationValue = last(durations).asSeconds()

export const IdpInformation = () => {
  const dispatch = useDispatch()
  const formikRef = useRef()
  const settings = useSelector(samlSettingsSelector)
  const sessionTimeoutIn = useSelector(orgSessionSettingsSelector)
  const samlErrors = useSelector(errorsSelector)

  const handleSubmit = (values) => dispatch(saveSamlSsoSettings(values))

  const validationSchema = useMemo(buildValidationSchema, [])

  useEffect(() => {
    if (!formikRef.current) return
    if (!samlErrors) return

    const { setFieldError } = formikRef.current

    Object.entries(samlErrors).forEach(([field, error]) => {
      setFieldError(field, Array.isArray(error) ? error[0] : error)
    })
  }, [samlErrors])

  const initialValues = {
    entity_id: '',
    sso_url: '',
    certificate: '',
    ...settings,
    session_settings: {
      session_timeout_in: sessionTimeoutIn || defaultDurationValue
    },
  }

  return (
    <Form
      innerRef={formikRef}
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
    >
      <Row>
        <TextField
          name="entity_id"
          label={I18n.t('publisher.organization_settings.sso.idp_information.entity_id')}
          placeholder={I18n.t('publisher.organization_settings.sso.idp_information.entity_id_placeholder')}
        />
      </Row>
      <Row>
        <TextField
          name="sso_url"
          label={I18n.t('publisher.organization_settings.sso.idp_information.sso_url')}
          placeholder={I18n.t('publisher.organization_settings.sso.idp_information.sso_url_placeholder')}
        />
      </Row>
      <Row>
        <JustifiedGrid>
          <GridItem>
            <label htmlFor="certificate">
              <CertificateLabel>
                <div>
                  {I18n.t('publisher.organization_settings.sso.idp_information.certificate')}
                  <Hint>
                    {I18n.t('publisher.organization_settings.sso.idp_information.certificate_hint')}
                  </Hint>
                </div>
              </CertificateLabel>
            </label>
          </GridItem>
          <GridItem>
            <CertificateFileInput name="certificate" />
          </GridItem>
        </JustifiedGrid>
        <TextField
          name="certificate"
          type="textarea"
          id="certificate"
          placeholder={I18n.t('publisher.organization_settings.sso.idp_information.certificate_placeholder')}
        />
      </Row>
      <Row>
        <SessionDurationSelectField
          name="session_settings.session_timeout_in"
          label={I18n.t('publisher.organization_settings.sso.idp_information.session_duration')}
          ariaLabel="sessionDurationLabel"
        />
      </Row>
      <Row>
        <p>{I18n.t('publisher.organization_settings.sso.idp_information.warning')}</p>
      </Row>
      <StepControls>
        <SubmitFormButton>{I18n.t('publisher.action.save_and_continue')}</SubmitFormButton>
      </StepControls>
    </Form>
  )
}
